import { useContainerBlockContext } from '@lighthouse/block'
import type { FilterBlockAbstract, FilterFormType } from '@lighthouse/core'
import { filterBlock, getFilterBlockItemIdsInFilter, recTakeFilterVariable, resolveFilter4Block, useAtomData } from '@lighthouse/shared'
import { useCallback, useMemo } from 'react'

import { syncComponentsAtom } from '@/atoms/application/state'
import { pageBlocksAtom } from '@/atoms/page/state'
import { useParseVariableWithSubscription } from '@/hooks/useParseVariable'

interface UseLinkFilterPayload {
    appId: string
    envId: string
    pageId: string
    linkFilterController?: FilterFormType
}

export const useLinkFilter = (payload: UseLinkFilterPayload) => {
    const { appId, envId, pageId, linkFilterController } = payload
    const filterVariables = useMemo(
        () => linkFilterController && recTakeFilterVariable(linkFilterController?.expression),
        [linkFilterController]
    )
    const parseVariable2Field = useParseVariableWithSubscription(filterVariables)
    // const [updateCount, setUpdateCount] = useState(0)
    const { scope } = useContainerBlockContext()
    // const filterOptions = useAtomData(filterBlockOptionsAtom)
    const { filterBlockItemIds } = useMemo(() => getFilterBlockItemIdsInFilter(linkFilterController), [linkFilterController])
    const filterBlockIds = useMemo(() => filterBlockItemIds.map(item => item.blockId), [filterBlockItemIds])
    // const filterValue = useAtomValue(filterBlockIdsCacheAtomFamily({ appId, envId, pageId, scope, filterBlockItemIds }))
    const filterBlocks = useAtomData(
        scope ? syncComponentsAtom : pageBlocksAtom(pageId),
        useCallback(
            s => filterBlock(s, block => block.type === 'filter' && filterBlockIds.includes(block.id)) as FilterBlockAbstract[],
            [filterBlockIds]
        )
    )
    // // const resolvedLinkFilterRef = useRef()
    const resolvedLinkFilter = useMemo(() => {
        if (!linkFilterController) {
            return
        }
        return resolveFilter4Block({
            filter: linkFilterController,
            filterBlocks,
            filterBlockParams: {
                parseVariable2Field
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linkFilterController, parseVariable2Field])

    return { resolvedLinkFilter }
}
